module.exports = __webpack_public_path__ + "assets/dd26603254145207d22cc5e5cf06abc7.png";